export enum TransactionType {
  RIDE_PAYMENT = "RIDE PAYMENT",
  RIDE_PAYMENT_CASH = "RIDE PAYMENT CASH",
  DRIVER_EARNING = "DRIVER_EARNING",
  PLATFORM_COMMISSION = "PLATFORM COMMISSION",
  RIDER_CANCELLATION_FEE = "RIDER CANCELLATION FEE",
  DRIVER_PENALTY_REVENUE = "DRIVER PENALTY REVENUE",
  PLATFORM_COMMISSION_CASH_RIDE = "PLATFORM COMMISSION FOR CASH RIDE",
  DRIVER_COUPON_CREDIT = "DRIVER COUPON CREDIT",

  DRIVER_BONUS = "DRIVER BONUS",
  DRIVER_PENALTY = "DRIVER PENALTY",

  RIDER_PAYMENT_ONLINE = "RIDER PAYMENT ONLINE",
  REFUND = "REFUND",
  PAYOUT = "PAYOUT",
  WALLET_TOPUP = "WALLET TOPUP",
  ADJUSTMENT = "ADJUSTMENT",
  DRIVER_SETTLEMENT = "DRIVER SETTLEMENT",
  COUPON_EXPENSE = "COUPON EXPENSE",
}
